import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from 'routes';
import { ThemeProvider, Backdrop, CircularProgress } from '@mui/material';
import { theme } from 'theme';
import { useIsFetching } from 'react-query';
import { useEffect, useState } from 'react';

function App() {
  const [loading, setLoading] = useState(false);
  const isFetching = useIsFetching();
  useEffect(() => {
    if (isFetching > 0) {
      setLoading(true);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 600);
    }
  }, [isFetching]);

  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
        <CircularProgress />
      </Backdrop>
    </ThemeProvider>
  );
}

export default App;
